import $http from "../../api/api.js";
import $public from "../../util/public.js";
// function getTotal(saleList,curDiscountCard){
// 	let arr = saleList
// 	let total = {
// 		total:0,
// 		activity:0,
// 	}
// 	for(let i=0;i<arr.length;i++){
// 		total.total = $public.jia(total.total, $public.cheng(arr[i].originalPrice,arr[i].num))
// 		total.activity = $public.jia(total.activity, $public.cheng(arr[i].price,arr[i].num))
// 	}
// 	let activityTotal = total.activity;
// 	if(curDiscountCard!==null){
// 		if(curDiscountCard.activity_type===1){ // 满减
// 			activityTotal = $public.jian(activityTotal,curDiscountCard.money_reduce);
// 		}else if(curDiscountCard.activity_type===2){ // 折扣
// 			let yh = $public.cheng(activityTotal,$public.jian(1,curDiscountCard.rebate));
// 			if(curDiscountCard.rebate_limit>0){
// 				if(yh>curDiscountCard.rebate_limit){
// 					yh=curDiscountCard.rebate_limit
// 				}
// 			}
// 			activityTotal = $public.jian(activityTotal,yh);
// 		}
// 	}
// 	total.activity = activityTotal;
// 	return total;
// }

export default {
  namespaced: true,
  state: {
    vipIndex:-1,//商品购物车里是否添加会员卡 -1没有添加会员卡
    isvip:false,
    selectdiscount: [],
    isSanke: false,
    cardCount: { card_count: 0, coupon_count: 0, gift_card_count: 0 },
    userController: [],
    userInfo: {},
    curPetId: "",
    curCardObj: {},
    curBusiness: "消费",
    saleList: [],
    saleTotal: { total: 0, activity: 0,showVip:false },
    remark: "",
    remarkGuahao: "",
    jiedanItem: null,
    curDiscountCard: null,
    isCollapse: "0",
    unPayOrderList: [],
    unPayOrderNoList: [],
    dingjinOrder: [],
    waitCount: {},
    jiedaiLength: {
      order: 0,
      guahao: 0,
      ximei: 0,
      jiyang: 0,
      zhuyuan: 0,
      YMQC: 0,
    },
    huiyuanquanyiNum: 0,
    curNavPanelPet: "0",
  },
  getters: {
    curPetInfo(state) {
      if (
        state.userInfo.pets_info &&
        state.userInfo.pets_info[0] &&
        state.curPetId
      ) {
        return state.userInfo.pets_info.filter((item) => {
          state.userInfo.pets_info.map((item, index) => {
            if (item.bron_date) {
              return state.userInfo.pets_info[index].petAgeArr = $public.calculatePetAge(item.bron_date)
            }
          })
          return item._id == state.curPetId;
        })[0];
      } else {
        return {};
      }
    },
  },
  mutations: {
    set_isvip(state){
      state.isvip = !state.isvip
    },
   
    
    set_selectdiscount(state, params) {
      state.selectdiscount = params;
    },
    set_isSanke(state, params) {
      state.curBusiness = "消费";
      state.isSanke = params;
      if (params === true) {
        let info = {
          _id: "sankeId",
          staff_type: 0, //  0：散客、1：顾客、2：在职员工、3：离职员工
          basic_info: {
            user_name: null,
            user_pwd: null,
            user_mobile: null,
            nick_name: "散客",
            real_name: null,
            avatar_pic: null,
            user_email: null,
            user_address: null,
            sex: null,
            birthday: null,
            user_type: 1,
            home_address: null,
            urgent_user: null,
            urgent_user_mobile: null,
            remark: "",
          },
          pet_count: {
            hsTotal: 0,//花生宠物的数量
            total: 0
          },
          club_card: {
            grades: 0,
            prev_grades: 0,
            score: 0,
            start_time: "",
            expires_time: "",
            change_time: "",
          },
          card_info: {
            card_id: null,
            user_yajin: 0,
            user_jifen: 0,
            user_zenge: 0,
            user_yue: 0,
            user_diyong: 0,
          },
          pets_info: [
            {
              _id: "sankechongwuId",
              nick_name: "散客宠物",
              chip_no: null,
              class_name: null,
              type_name: null,
              sex: null,
              color: null,
              hs_pet: false,
              status: 1,
              create_time: "",
              sterilization: 0,
              immunization: 0,
              dewormed: 0,
              remark: null,
              birth_day: null,
              home_day: null,
              xiang_ban: null,
              chu_sheng: null,
              avatar_pic: null,
              tool_num: null,
              weight: 0,
              weight_remark: null,
              create_member_id: "",
              create_member_name: "",
              weight_records: [],
            },
          ],
          status: 1,
          company_info: {
            company_id: "",
            company_name: "",
            shop_id: "",
            shop_name: "",
          },
          operation_info: {},
        };
        state.userInfo = info;
        state.curPetId = "sankechongwuId";
        state.unPayOrderList = [];
      }
    },
    set_cardCount(state, obj) {
      state.cardCount = obj;
    },
    set_vipIndex(state,obj){
      state.vipIndex = obj;
    },
    set_dingjinOrder(state, obj) {
      state.dingjinOrder = obj;
    },
    set_userController(state, obj) {
      state.userController = obj;
    },
    set_userInfo(state, obj) {
      if (!obj) return;
      if (state.userInfo._id !== obj._id) {
        state.curBusiness = "消费";
      }
      state.userInfo = obj;
    },
     set_curPetId(state, obj) {
      state.curPetId = obj;
    },
    set_curCardObj(state, obj) {
      state.curCardObj = obj;
    },
    set_CardId(state, obj) {
      state.curCardId = obj;
    },
    set_curBusiness(state, obj) {
      state.curBusiness = obj;
    },
    set_saleList(state, arr) {
      state.saleList = arr
    },
    set_push_set_SaleList(state,item){
      state.saleList.push(item)
      //用于触发计算价格
      state.isvip = !state.isvip
    },
    set_saleTotal(state, obj) {
      state.saleTotal = obj;
    },
    set_remark(state, obj) {
      state.remark = obj;
    },
    set_remarkGuahao(state, obj) {
      state.remarkGuahao = obj;
    },
    set_jiedanItem(state, obj) {
      state.jiedanItem = obj;
    },
    set_curDiscountCard(state, obj) {
      state.curDiscountCard = obj;
    },
    set_isCollapse(state, obj) {
      state.isCollapse = obj;
    },
    set_unPayOrderNoList(state, no) {
      let b = -1;
      for (let i = 0; i < state.unPayOrderNoList.length; i++) {
        if (no === state.unPayOrderNoList[i]) {
          b = i;
        }
      }
      if (b === -1) {
        state.unPayOrderNoList.push(no);
      } else {
        state.unPayOrderNoList.splice(b, 1);
      }
    },
    set_jiedaiLength(state, obj) {
      state.jiedaiLength = obj;
    },
    set_huiyuanquanyiNum(state, obj) {
      state.huiyuanquanyiNum = obj;
    },
    set_curNavPanelPet(state, obj) {
      state.curNavPanelPet = obj;
    },
    reset(state) {
      state.isSanke = false;
      state.userInfo = {};
      state.curPetId = "";
      state.saleList = [];
      state.remark = "";
      state.remarkGuahao = "";
      state.jiedanItem = null;
      state.curDiscountCard = null;
      state.cardCount = { card_count: 0, coupon_count: 0, gift_card_count: 0 };
      state.huiyuanquanyiNum = 0;
      state.vipIndex = -1;
      state.curNavPanelPet = "0";
      state.dingjinOrder = [];
    },
  },
  actions: {
    get_unPayOrderList({ state }) {
      if (state.userInfo._id) {
        let params = {
          keyword: "",
          userid: state.userInfo._id, // 用户id
          starttime: "",
          endtime: "",
          state: "1,2",
          pay_type: "", // 支付方式
          pageIndex: 1,
          pageSize: 100,
          order_type: "", // 全部：''  消费：'消费'  医疗：'医疗'
        };
        $http.post("/api/Order/OrderList", params).then((res) => {
          if (res.code == 0) {
            state.unPayOrderList = res.data.data;
          }
        });
      } else {
        state.unPayOrderList = [];
      }
    },
    getWaitCount({ state }) {
      let params = {};
      $http.get("/api/Platform/WaitCount", params).then((res) => {
        if (res.code == 0) {
          state.waitCount = res.data;
        }
      });
    },
    getCardDetail({ commit },params) {
      $http.get(process.env.VUE_APP_apiHost+"api/Product/VipCard/Detail", {id:params.id}).then((res) => {
        if (res.code == 0) {
          let goods = {
            activityId: "",
            activityItem: {},
            activityList: [],
            couponList: [],
            customCode: "",
            totaTimes: 1, // 总次数
            useTimes: 0, // 已使用次数
            onlyTimes: 1,
            tableKey:'', //tableKey605a8b2c652fbf8339c22620 差价 tableKey605996155011826976dd8114 娱乐
            petId: '',
            petName: '',
            brand: "",
            categoryId: '',
            categoryName:'',
            huotiType: 0,
            goodsId:res.data._id,
            goodsName: res.data.title,
            goodsType: 12, //  0:商品 1:药品 2.生活服务 3.优惠券 4.医疗服务 5.活体 6.卡 7.耗材 8.组合套餐
            goodsUsage: "", // 用法
            goodsDosage: "", // 用量
            originalPrice: res.data.price, // 原价
            vipPrice:res.data.vipPrice,
            price: res.data.price, // 现价
            costPrice: 0,
            num: 1, // 数量
            skus: res.data.sku_name,
            skuValue: res.data.sku_name,
            unitId: "",
            unit: "",
            totalMoney: 0,
            staff: [], // 销售人员
            validityStopDate: res.data.days, // 有效期
            goodsList: [],
            giftList: [],
            checkGoods: [],
            saleWays: "",
            packingExchangesStr: "",
            buyBack:1,
          };
          
          commit('set_push_set_SaleList',goods)
         
        }
      });
    },
    getJiedaiLength({ commit, rootState }) {
      let arr = {
        order: 0,
        guahao: 0,
        ximei: 0,
        jiyang: 0,
        zhuyuan: 0,
        YMQC: 0,
      };
      // 商品
      let curDay = $public.FTime(new Date().getTime(), "YYYY-MM-DD");
      let params = {
        keyword: "", //关键词
        userid: "", // 用户id
        pet_id: "", //宠物id
        starttime: ("" + (new Date(curDay).getTime() - 28800000)).substr(0, 10), //开始时间
        endtime: (
          "" +
          (new Date(curDay).getTime() + 86400000 - 28800000)
        ).substr(0, 10), //结束时间
        pay_starttime: "", //支付开始时间
        pay_endtime: "", //支付结束时间
        state: "", //状态
        pay_type: "", // 支付方式
        create_manager_id: "", //创建人id
        order_type: "", //订单类型
        order_type_id: "", //订单类型id
        sales_id: "", //销售人员id
        pageIndex: 1,
        pageSize: 1,
      };
      $http.post("/api/Order/OrderList", params).then((res) => {
        if (res.code == 0) {
          arr.order = res.data.count;
          commit("set_jiedaiLength", arr);
        }
      });
      // 挂号
      params = {
        status: 0, // 1待接诊；2已接诊；3已完成
        is_mine: false,
        memberId: "",
        begin_time: ("" + (new Date(curDay).getTime() - 28800000)).substr(
          0,
          10
        ), //开始时间
        end_time: (
          "" +
          (new Date(curDay).getTime() + 86400000 - 28800000)
        ).substr(0, 10), //结束时间
        departmentId: 0,
        isTransfer: 0,
        keyword: "",
        pageIndex: 1,
        pageSize: 1,
      };
      $http.post("/api/Registration/List", params).then((res) => {
        if (res.code == 0) {
          arr.guahao = res.data.count;
          commit("set_jiedaiLength", arr);
        }
      });
      // 洗美
      params = {
        memberId: "",
        petId: "",
        status: 0, // 0不限；1进行中；2已完成
        isPay: -1,
        startTime: ("" + (new Date(curDay).getTime() - 28800000)).substr(0, 10), //开始时间
        endTime: (
          "" +
          (new Date(curDay).getTime() + 86400000 - 28800000)
        ).substr(0, 10), //结束时间
        pageIndex: 1,
        pageSize: 1,
        keyword: "",
      };
      $http.post("/api/WashBeauty/List", params).then((res) => {
        if (res.code == 0) {
          arr.ximei = res.data.count;
          commit("set_jiedaiLength", arr);
        }
      });
      // 寄养
      params = {
        // startDate: ('' + (new Date(curDay).getTime()-28800000)).substr(0, 10),  //开始时间
        // endDate: ('' + (new Date(curDay).getTime()+86400000-28800000)).substr(0, 10),	//结束时间
        startDate: "", //开始时间
        endDate: "", //结束时间
        status: 0,
        depositType: 0,
        autoDeduct: -1,
        petId: "",
        pageIndex: 1,
        pageSize: 1,
        keyword: "",
      };
      $http.post("/api/FosterCare/List", params).then((res) => {
        if (res.code == 0) {
          arr.jiyang = res.data.count;
          commit("set_jiedaiLength", arr);
        }
      });
      // 住院
      params = {
        keyword: "",
        // "petId": this.curPetId,
        memberId: "",
        status: 0, // 0不限；1：住院中；2：已离院
        isPay: -1, // （-1不限：0未支付；1：已支付）
        depositType: 0, // (0不限；1：押金；2：余额)
        startTime: ("" + (new Date(curDay).getTime() - 28800000)).substr(0, 10), //开始时间
        endTime: (
          "" +
          (new Date(curDay).getTime() + 86400000 - 28800000)
        ).substr(0, 10), //结束时间
        desc: true,
        pageIndex: 1,
        pageSize: 1,
      };
      $http.post("/api/InHospital/List", params).then((res) => {
        if (res.code == 0) {
          arr.zhuyuan = res.data.count;
          commit("set_jiedaiLength", arr);
        }
      });
      // YMQC
      params = {
        keyword: "",
        petId: "",
        serviceTypeId: 0, // 1疫苗；2驱虫; Default:0
        isPay: 1, // -1 全部；0未支付；1已支付
        petType: "", //  猫类；犬类
        status: this.radio, // 1未完成；2已完成
        isOut: 0, // -1 0 1 2
        hasGoods: false,
        desc: true,
        shopId: rootState.shopId,
        planBeginDate: ("" + (new Date(curDay).getTime() - 28800000)).substr(
          0,
          10
        ), //开始时间
        planEndDate: (
          "" +
          (new Date(curDay).getTime() + 86400000 - 28800000)
        ).substr(0, 10), //结束时间
        pageIndex: 1,
        pageSize: 1,
      };
      $http.post("/api/MedicalPackage/Plan/List", params).then((res) => {
        if (res.code == 0) {
          arr.YMQC = res.data.count;
          commit("set_jiedaiLength", arr);
        }
      });
    },
    getUserInfo({ commit }, id) {
      $http.get(process.env.VUE_APP_Url_member + "/api/middleware/Member/Single", { id: id }).then((res) => {
        if (res.code == 0) {
          commit("set_userInfo", res.data);
          if ($public.isNull(res.data.pets_info)) {
            commit("set_curPetId", "");
          } else {
            commit('set_curPetId', res.data.pets_info[0]._id)
          }

          // 获取会员权益数量
          let num = 0;
          for (let i = 0; i < res.data.pets_info.length; i++) {
            let petItem = res.data.pets_info[i];
            console.log(res.data.pets_info[i].hundred_assure,'会员权益','petItem');
            // commit("set_hundredAssure", hundred_assure);
            if (petItem.medical_money && petItem.medical_money.status === 1) {
              num++;
            }
            if (petItem.hundred_assure && petItem.hundred_assure.status === 1) {
              num++;
            }
          }
          commit("set_huiyuanquanyiNum", num);
        }
      });
      $http
        .get(
          process.env.VUE_APP_Url_member +
          "/api/middleware/Member/ServiceCountList",
          { memberId: id }
        )
        .then((res) => {
          if (res.code == 0) {
            commit("set_cardCount", res.data);
          }
        });
      // 获取宠物订金订单
      $http
        .get("/api/Order/DepositOrder", {
          userId: id,
          isUse: 2,
          pageIndex: 1,
          pageSize: 50,
        })
        .then((res) => {
          if (res.code == 0) {
            commit("set_dingjinOrder", res.data.data);
          }
        });
    },
    newGetUserInfo({ commit }, id) {
      $http.get(process.env.VUE_APP_Url_member + "/api/middleware/Member/Single", { id: id }).then((res) => {
        if (res.code == 0) {
          commit("set_userInfo", res.data);
          if ($public.isNull(res.data.pets_info)) {
            commit("set_curPetId","");
          }
          // 获取会员权益数量
         
          let num = 0;
          for (let i = 0; i < res.data.pets_info.length; i++) {
            console.log(res.data.pets_info[i].hundred_assure,'会员权益');
            let petItem = res.data.pets_info[i];
            if (petItem.medical_money && petItem.medical_money.status === 1) {
              num++;
            }
            if (petItem.hundred_assure && petItem.hundred_assure.status === 1) {
              num++;
            }
          }
          commit("set_huiyuanquanyiNum", num);
        }
      });
      $http
        .get(
          process.env.VUE_APP_Url_member +
          "/api/middleware/Member/ServiceCountList",
          { memberId: id }
        )
        .then((res) => {
          if (res.code == 0) {
            commit("set_cardCount", res.data);
          }
        });
      // 获取宠物订金订单
      $http
        .get("/api/Order/DepositOrder", {
          userId: id,
          isUse: 2,
          pageIndex: 1,
          pageSize: 50,
        })
        .then((res) => {
          if (res.code == 0) {
            commit("set_dingjinOrder", res.data.data);
          }
        });
    },
  },
};
